import { render, staticRenderFns } from "./AcmFooter.vue?vue&type=template&id=30ade9b1&scoped=true&"
import script from "./AcmFooter.vue?vue&type=script&lang=js&"
export * from "./AcmFooter.vue?vue&type=script&lang=js&"
import style0 from "./AcmFooter.vue?vue&type=style&index=0&id=30ade9b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ade9b1",
  null
  
)

export default component.exports